import * as React from 'react';
export const IcStream = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.6 8.82a1 1 0 00-1.2-1.6 6 6 0 000 9.56A1 1 0 009 17a1 1 0 00.6-1.8 4 4 0 010-6.36v-.02zM4 12a8 8 0 013.56-6.61 1.001 1.001 0 00-1.12-1.66 9.92 9.92 0 000 16.54 1 1 0 001.03.053 1 1 0 00.09-1.713A8 8 0 014 12zm14 0a5.93 5.93 0 00-2.4-4.78 1 1 0 10-1.2 1.6 4.001 4.001 0 010 6.36 1 1 0 001.2 1.6A5.929 5.929 0 0018 12zm-6-2a2 2 0 100 4 2 2 0 000-4zm5.56-6.27a1.001 1.001 0 10-1.12 1.66 7.92 7.92 0 010 13.22 1 1 0 101.12 1.66 9.92 9.92 0 000-16.54z'
      fill='currentColor'
    />
  </svg>
);
